export default {
  translation: {
    app_title: "Qandel Blbas Co.",
    b_app_title: " Factory",
    sm_app_title: "Al-Smood Factory",
    br_app_title: "Al-Qandel Brc Factory",
    home1: "General Trading, Steel, Construction Materials,\n Industrial Chemical Materials, and General Contracting Company Limited",
    home2: "General Trading, Steel, Construction Materials, \n Industrial Chemical Materials, and General Contracting Company Limited",
    home3: "General Trading, Steel, Construction Materials, \n Industrial Chemical Materials, and General Contracting Company Limited",
    home4: "General Trading, Steel, Construction Materials, \n Industrial Chemical Materials, and General Contracting Company Limited",
    home: "Home",
    about: "About",
    services: "Services",
    partners: "Partners",
    sanaPanel: "Al-Hayat Panel",
    powerPanel: "Al-Qwa Panel",
    power: "Qwa",
    blackPipe: "Black Pipe",
    qandelBrc: "Al-Qandel Brc",
    alSmood: "Al-Smood",
   
    products: "Our Products",
    pdfdw:"Download Pdfs",
    contact: "Contact",
    about_us:"About Us",
    core:"Our Core Capabilities & Partnerships",
    targetp:"Our vision is to become a trusted regional and international partner in supporting urban growth, infrastructure development, and industrial expansion.",
    target1p:"Our commitment is to build long-term partnerships with our clients by delivering guaranteed quality, competitive pricing, and practical solutions tailored to the specific needs of each project.",
    objectiv:"Our Objectives:",
    ob1:"Strategic Expansion: Increasing our market share by leveraging existing supplier networks in Turkey, Egypt, the UAE, and China to introduce new product lines to the local market.",
    ob2:"Innovation in Construction: Pioneering the use of PIR Sandwich Panels and advanced steel sections to reduce project timelines and improve thermal efficiency in Iraq’s infrastructure.",
    ob3:"Operational Excellence: Integrating rapid execution techniques with sustainable building practices without compromising our rigorous safety benchmarks.",
    about_p: `Since its establishment in Erbil in 2010, our company has built a strong reputation as a leading general trading and contracting firm, specializing in steel, construction materials, industrial chemicals, and infrastructure supply solutions. Through years of experience and consistent performance, we have positioned ourselves as a reliable partner for both public and private sector projects.
We maintain a robust international supply network with major manufacturers and suppliers in Turkey, Egypt, the United Arab Emirates, China, and other global markets. These relationships enable us to provide our clients with high-quality products that meet international standards at competitive prices, while ensuring dependable and timely delivery.
`,
    pf:"Our company offers a comprehensive portfolio of materials, including:",
    pf1:"Steel and reinforcement materials",
    pf2:"Structural steel sections",
    pf3:"Welded wire mesh",
    pf4:"Essential construction and building supplies",
    pf5:"Industrial chemicals used in infrastructure, oil & gas, and various industrial ",
    pf6:"Trading with oil companies and providing transportation and securities services. ",
    aboutp1:"In addition to trading, we provide contracting services covering both supply and project execution, ensuring that every project is delivered according to the highest standards of quality, efficiency, and safety.",
    aboutp2:`We are also licensed to conduct business in/ with United States and actively pursue strategic partnerships with American companies, enabling us to expand our supply capabilities, access advanced technologies, and strengthen international cooperation in construction and industrial development.`,
    why_chose_us: "Why Choose Us ?",
    reason1: "Trust in the market. ",
    reason2:"Fast execution of special requests.",
    reason3:"Experience of more than 30 years.",
    contact_form: "Contact Form",
    name: "Name",
    email: "E-mail",
    message: "Message",
    send_message: "Send Message",
    contact_p:
      "An Iraqi delivery company. Our goal is to give the best model for delivery companies by employing expertise and using the latest internationally approved technology.",
    address: "Address",
    address_value:
      "Head Office: Iraq , Erbil , Runaki St., opposite to WestEye Hospital ,Said Taib building ,7th Floor, Office No. 701",
    phone: "Phone",
    copy_right: "© All Rights Reserved Qandel blbas Co.",
    page_not_found: "Page Not Found",
    is_required: "is required!",
    not_valid: "is not a valid email!",
    service1: "cutting in length",
    service1_p:
      "To cut rolls and turn them into waiters (ties) according to requests, and for all types of galvanized iron, colored, cold black roll, hot black roll.",
    service1_li1: "Roll width: from 40 cm to 150 cm",
    service1_li2: "Roll thickness: 0.20 mm to 2.00 mm",
    service1_li3: "Cutting length: from 125 cm to 700 cm",
    service2: "Making corrugated steel sheets",
    service2_p:
      "To produce kirby panels (roof gables) for the roofs of buildings, warehouses and yards.",
    service2_li1: "Roller width used: 120cm, 122cm, 125cm.",
    service2_li2: "Product Width: 100cm (Net).",
    service2_li3: "Plate thickness: 0.20 to 0.90 mm",
    service2_li4: "The length of the kirby: from 125 cm to 1700 cm",
    service3: "Cold Saw Blades",
    service3_p:
      "Cold Saw Blades Supply, sharpen, and repair cold saw blades",
    service4: "Oil Industry",
    service4_p: `Setup Venture provides premium logistics and technical services for oil projects. We guarantee operational efficiency and safety through full compliance with international standards.`,
    service5: "Security",
    service5_p: `Expat Compass provides holistic security for people and assets by integrating physical protection with advanced technology. Backed by a 40-year legacy of trust in Iraq, we guarantee seamless and reliable protection for your operations.`,
    view_pdf: "View Profile Catalog",

    s_top_header1: "AlHayat Panel Manufacturer of sandwich panels",
    s_about_p:
      "AlHayat panel is a local factory established in 2017 .The factory started to produce sandwich panel for both roof and wall in 2018. The production of this factory is with automated machine and high quality with standard requirements and costumer demands meet. The aim of the company is to develop and reconstruct the country with a local product and provide more job opportunities.",
    s_whatspanel: "Whats Sandwich Panel",
    s_whatspanel_p:
      "Actually sandwich panel is three ply light compound structure, Shows extraordinary performances and advantages. A sandwich panel compound, in comparison with its components has much more resistance and also can be used qqickly and easily in constructions. In this modern construction material, insulation polyurethane foam or layers wwith specific physical features such as defined density and fire resitance calss, placed between external and internal layers. These three components are inseparable, and function as integrated object. Whereas are very good heat and cold insulation, using them cause energy costs significantly reduce.",
    s_availables: "Available Dimentions & Thikness",
    s_specifics: "Specifications",
    s_spec_width: "Width",
    s_spec_length: "Length",
    s_spec_thikness: "Thikness",
    s_spec_density: "Density",
    s_spec_thermal: "Thermal Conductivity",
    s_spec_sound: "Sound Isolation",
    s_roof: "Roof Panel",
    s_wall: "Wall Panel",
    s_f_1: "1000 mm",
    s_f_2: "18 m max",
    s_f_3: "50, 75, 100 mm",
    s_f_4: "40 kg/m",
    s_f_4a: " (∓2)",
    s_f_5: "0.022 w/mk",
    s_f_6: "25 dB",
    s_application: "Application",
    s_application_p:
      "Sandwich panel can be widly used in the construction of factories, showrooms, offices, restaurant, theaters, schools, malls, ssupermarkets, warehouses, poultry halls, ssport clubs, airport, terminals, etc",
    s_type: "Product Types",
    s_type1: "Sandwich Panel Rigid Polyurethane (PUR)",
    s_type2: "Sandwich Panel Polyisocyanurate (PIR)",
    s_type3: "Sandwich Panel Ridges",
    s_specification: "Specifications",
    s_specific_1: "Rain and vapor resistance",
    s_specific_2: "Rusting reesistance",
    s_specific_3: "Wind resistance",
    s_specific_4: "Sun light resistance",
    s_specific_5: " Chemical resistance",
    s_specific_6: " Fire resistance",
    s_specific_7: "Heat insulation",
    s_specific_8: "Sound insulation",
    s_specific_9: "Thrust and earthquake resistance",
    s_specific_10: "Insects resistance",
    s_specific_11: "Nice apperance",
    s_specific_12: "Protective against pollutions",
    s_specific_13: "Cost effective",
    s_specific_14: "Variable colors",
    s_specific_15: "High durability",
    s_specific_16: "Recyclable",
    s_add_value: "Kirkuk, Kirkuk Ring Road, Near Laylan bridge",
    p_top_header1: "Al-Qwa Panel Manufacturer of sandwich panels",
    p_about_p:
      "al-qwa panel is a local factory established in 2017 .The factory started to produce sandwich panel for both roof and wall in 2018. The production of this factory is with automated machine and high quality with standard requirements and costumer demands meet. The aim of the company is to develop and reconstruct the country with a local product and provide more job opportunities.",
    p_whatspanel: "Whats Sandwich Panel",
    p_whatspanel_p:
      "Actually sandwich panel is three ply light compound structure, Shows extraordinary performances and advantages. A sandwich panel compound, in comparison with its components has much more resistance and also can be used qqickly and easily in constructions. In this modern construction material, insulation polyurethane foam or layers wwith specific physical features such as defined density and fire resitance calss, placed between external and internal layers. These three components are inseparable, and function as integrated object. Whereas are very good heat and cold insulation, using them cause energy costs significantly reduce.",
    p_availables: "Available Dimentions & Thikness",
    p_specifics: "Specifications",
    p_spec_width: "Width",
    p_spec_length: "Length",
    p_spec_thikness: "Thikness",
    p_spec_density: "Density",
    p_spec_thermal: "Thermal Conductivity",
    p_spec_sound: "Sound Isolation",
    p_roof: "Roof Panel",
    p_wall: "Wall Panel",
    p_f_1: "1000 mm",
    p_f_2: "18 m max",
    p_f_3: "50, 75, 100 mm",
    p_f_4: "40 kg/m",
    p_f_4a: " (∓2)",
    p_f_5: "0.022 w/mk",
    p_f_6: "25 dB",
    p_application: "Application",
    p_application_p:
      "Sandwich panel can be widly used in the construction of factories, showrooms, offices, restaurant, theaters, schools, malls, ssupermarkets, warehouses, poultry halls, ssport clubs, airport, terminals, etc",
    p_type: "Product Types",
    p_type1: "Sandwich Panel Rigid Polyurethane (PUR)",
    p_type2: "Sandwich Panel Polyisocyanurate (PIR)",
    p_type3: "Sandwich Panel Ridges",
    p_specification: "Specifications",
    p_specific_1: "Rain and vapor resistance",
    p_specific_2: "Rusting reesistance",
    p_specific_3: "Wind resistance",
    p_specific_4: "Sun light resistance",
    p_specific_5: " Chemical resistance",
    p_specific_6: " Fire resistance",
    p_specific_7: "Heat insulation",
    p_specific_8: "Sound insulation",
    p_specific_9: "Thrust and earthquake resistance",
    p_specific_10: "Insects resistance",
    p_specific_11: "Nice apperance",
    p_specific_12: "Protective against pollutions",
    p_specific_13: "Cost effective",
    p_specific_14: "Variable colors",
    p_specific_15: "High durability",
    p_specific_16: "Recyclable",
    p_add_value: "Duhok, Zakho, Hasan Ava, Behind the car showroom",
    b_top_header1: "Black Pipe Factory Manufacturer of pipes and steel profiles",
    b_about_p: "Black Pipe Factory produces the best pipes and steel profiles in various sizes with new and advanced lines according to Iraqi and international standards and by skilled and experienced engineers.Our factory was established in 2021 and in a short time due to its products in terms of quality and quantity has established its position in the market.Our factory aims to rely on local engineers and employees and provide the best type of profile and steel pipe, and meet the demands in a short time so that we no longer need to import foreign products.",
    b_type1: "Hot Rolled Steel Profiles and Tubes",
    b_type2: "Cold Rolled Steel Profiles and Tubes",
    b_type3: "Galvanized  Steel Profiles and Tubes",
    b_di1:"Round tubes",
    b_di2:"Square tubes",
    b_di3:"Rectangular tubes",
    b_di4:"Sectional tubes",
     round: "ROUND",
    p10: "10",
    p16: "16",
    p18: "18",
    p21: "21",
    p25: "25",
    p28: "28",
    p32: "32",
    p38: "38",
    p42: "42",
    p48: "48",
    p57: "57",
    p60: "60",
    p76: "76",
    p89: "89",
    p101: "101",
    square: "Square",
    p15x15: "15*15",
    p20x20: "20*20",
    p25x25: "25*25",
    p30x30: "30*30",
    p40x40: "40*40",
    p50x50: "50*50",
    p70x70: "70*70",
    p80x80: "80*80",
    rectangle: "Rectangle",
    p10x20: "10*20",
    p10x40: "10*40",
    p20x40: "20*40",
    p20x50: "20*50",
    p25x50: "25*50",
    p30x40: "30*40",
    p30x50: "30*50",
    p30x60: "30*60",
    p40x60: "40*60",
    p40x80: "40*80",
    p50x100: "50*100",
    oval: "Oval",
    p20x40t: "20*40",
    tShape: "T shape",
    lShape: "L shape",
    zShape: "Z shape",
    r0_50: "0.50",
    r0_60: "0.60",
    r0_70: "0.70",
    r0_80: "0.80",
    r0_90: "0.90",
    r1_00: "1.00",
    r1_10: "1.10",
    r1_20: "1.20",
    r1_30: "1.30",
    r1_40: "1.40",
    r1_50: "1.50",
    r1_60: "1.60",
    r1_70: "1.70",
    r1_80: "1.80",
    r1_90: "1.90",
    r2_00: "2.00",
    r2_25: "2.25",
    r2_50: "2.50",
    r2_70: "2.70",
    r3_00: "3.00",
    check: "✓",
    greaterThan: ">",
    greaterThanEqual: ">>",
    b_add_value: "Iraq, Erbil, Gwer Street, near Qoretagh Village",
    br_add_value: "Location: Fallujah City – Anbar Governorate – Iraq",

    brabout_p:"Al Qandel Factory is one of the newest industrial facilities in Fallujah, specializing in the production of electrically welded reinforcement mesh (BRC). We rely on advanced automated production lines and use high quality steel raw materials to provide the Iraqi construction sector with products characterized by high precision and compliance with Iraqi and international standards. We are proud to contribute to the reconstruction of Anbar Governorate and Iraq as a whole.",
    brdesc:"What is BRC Reinforcement Mesh",
    brdesc_p:"BRC consists of electrically welded steel meshes made of longitudinal and transverse wires intersecting at right angles. It serves as an ideal alternative to traditional reinforcing bars (rebar) in concrete applications, saving time and effort while ensuring accurate reinforcement distribution.",
    brad:"Key Advantages:",
    brad1:"Execution Speed: Covers large areas in record time.",
    brad2:"Dimensional Accuracy: Regular and uniform openings ensure ideal stress distribution.",
    brad3:"Reduced Waste: Manufactured in specific sizes to minimize steel scrap.",
    brad4:"Welding Quality: Strong electric welding ensures mesh stability during concrete pouring.",
    brspe:"Technical Specifications",
    brspep:"We produce a wide variety of meshes to meet the needs of residential, industrial, and infrastructure projects.",
    feature:"Feature",
    specification:"Specification",
    ad:"Available Diameters",
    ad1:"3.50 mm – 14 mm",
    od:"Opening Dimensions",
    od1:"From 100×100 mm to 250×250 mm",
    sd:"Standard Sheet Dimensions",
    sd1:"2 × 6 meters (customizable upon request)",
    ms:"Mesh Shape",
    ms1:"Square or rectangular as desired",
    note_p:"Note:Sheets can be manufactured in non standard dimensions according to project requirements, with lengths reaching customer specifications.",
    feilofap:"Fields of Application",
    foa1:"Foundations: Reinforcing reinforced concrete footings, rafts, and slabs.",
    foa2:"Ceilings (Slabs): An effective alternative to traditional reinforcement in flat slabs and dropped beams.",
    foa3:"Roads and Bridges: Reinforcing pavement layers, concrete bridges, and pedestrian walkways.",
    foa4:"Precast Elements: Used in block factories, curbstones, concrete pipes, and wall panels.",
    foa5:"Fencing: Meshes with suitable openings and diameters can be provided for fences upon request.",
    brwhy:"Why Choose Al Qandel Factory",
    brwhy1:"Production Flexibility: Full coverage of wire diameters from 3.5 mm to 14 mm and all required opening sizes.",
    brwhy2:"6 Meter Standard Sheets: Reduces the number of joints and speeds up execution, with the ability to manufacture special lengths.",
    brwhy3:"High Quality: Use of steel billets compliant with specifications, with periodic testing for yield strength, tensile strength, and weld stability.",
    brwhy4:"Modern Technology: Automated production lines utilizing digital control for high quality electric welding.",
    brwhy5:"High Production Capacity: Ability to meet large project orders in record time.",
    brwhy6:"Delivery Service: A fleet of trucks to deliver orders to Fallujah and all other governorates.",
    quality:"Quality and Standards",
    quality_p:"Our products comply with the Iraqi Quality Standard (IQS) and relevant international standards. Periodic tests are conducted in accredited laboratories to ensure the compliance of welds, dimensions, and mechanical properties.",
    br_top_header1:"Al Qandel for manifucturing BRC Meshes",

    smabout_p:"Located in Ameriyat Al-Samood, Al-Smood Factory was established as a pioneering industrial facility in the production of steel pipes and sections. We utilize state-of-the-art production lines to provide high-quality products that meet local and international market requirements, adhering to the highest standards of engineering precision and quality.",
    sm_vision:"Our Vision",
    sm_vision_p:"To be the premier regional leader in the steel pipes and sections industry, contributing to a robust urban and industrial future by delivering products that combine superior durability with ultimate engineering precision.",
    sm_mission:"Our Mission",
    sm_mission_p:"At Al-Smood Factory, our mission is to provide high-quality steel solutions that comply with international standards, focusing on manufacturing innovation and production flexibility to meet all construction and industrial project needs with accuracy and reliability.",
    corvlaue:"Our Core Values",
    cor1:"Durability: Built to withstand the toughest environments.",
    cor2:"Precision: Total adherence to the finest technical details.",
    cor3:"Partnership: Your success is the foundation of our collaboration.",
    cor4:"Innovation: Constantly evolving our tech to redefine manufacturing excellence.",
    qua:"Quality & Technical Standards",
    qua_p:"At Al-Smood Factory, quality is not just a slogan; it is an integrated process that begins with the selection of raw materials (steel coils) and ends with testing the final product. We adhere to the highest manufacturing standards to ensure dimensional accuracy and consistent thickness in every piece leaving our factory in Amriyat Al-Samood.",
    comit:"Our Commitment to Standards",
    comit_p:"o	Iraqi Quality Standards (IQS): All our steel pipes and sections are manufactured to comply with approved Iraqi standards for quality and durability.",
    chs:"Circular Hollow Sections ",
    dimen:"Dimensions & Thickness Details:",
    or:"Overall Range",
    or1:"From 15.88 mm to 219 mm",
    sm:"Small Sizes ",
    sm1:"(15.88 – 50.8 mm): Thickness starts from 0.60 mm",
    md:"Medium Sizes ",
    md1:"(101 – 114 mm): Thickness starts from 1.50 mm",
    lg:"Large Sizes",
    lg1:"(Up to 219 mm): Thickness starts from 2.50 mm",
    shs:"Square Hollow Sections ",
    or2:"From 15×15 mm to 175×175 mm",
    sm2:"(15×15 – 40×40 mm): Thickness starts from 0.60 mm",
    md2:"(90×90 – 100×100 mm): Thickness starts from 1.50 mm",
    lg2:"(Up to 175×175 mm): Thickness starts from 2.50 mm",
    rhs:"Rectangular Hollow Sections ",
    or3:"From 10×15 mm to 150×200 mm",
    sm3:"(10×15 – 30×50 mm): Thickness starts from 0.60 mm",
    md3:"(50×100 – 75×150 mm): Thickness starts from 1.50 mm",
    lg3:"(Up to 150×200 mm): Thickness starts from 2.50 mm",
    cs:"Customized Lengths & Special  Orders ",
    sl:"Standard Length: 6 meters.",
    cl:"Custom Lengths: Production available upon request from 3 meters up to 12 meters.",
    product:"Product Applications & Use Cases ",
    product_p:"Al-Smood Factory's pipes and sections are characterized by their versatility, high precision, and durability, making them the ideal choice for a wide range of industrial and construction sectors, including:",
    pro1:"Construction & Building: Manufacturing of doors, windows, and steel structures for buildings and warehouses.",
    pro2:"Metal Industries: Fabrication of complex metal structures and platforms.",
    pro3:"Furniture Industry: Steel frames for modern home and office furniture.",
    pro4:"Agricultural Sector: Design of irrigation and sprinkler systems, and construction of greenhouse structures.",
    pro5:"Infrastructure: Engineering of barriers, security fencing, and lighting poles.",
    sm_top_header1: "Al-Smood Factory Manufacturer of pipes and steel profiles",
    sm_add_value:"Iraq, Anbar Governorate, Amiriyat Al-Fallujah, Al-Somood Industrial Complex",

    "rs_slogan": "Raw Steel: The Pioneer in Galvanized and Pre-Painted Steel Sheet Production Across Iraq and Kurdistan.",
    "rs_about_title": "About Us",
    "rs_about_desc1": "Raw Steel is a strategic and unprecedented industrial project in Iraq and the Kurdistan Region, specializing in the painting, coating, and galvanizing of steel sheets and coils. Our state-of-the-art facility is established in the Erbil Governorate, spanning a total area of 84,000 square meters—over 32% of which is dedicated to green spaces to ensure environmental sustainability.",
    "rs_about_desc2": "By leveraging the latest global technologies and advanced production lines, we are committed to delivering high-quality products that compete robustly on an international scale. Our project serves as a cornerstone for both the public and private sectors, playing a pivotal role in reducing reliance on foreign imports and creating direct and indirect employment opportunities for our nation's youth.",
    "rs_vision_title": "Vision",
    "rs_vision_desc": "To become the largest and most trusted supplier of galvanized and color-coated steel coils across Iraq and the wider Middle East.",
    "rs_mission_title": "Mission",
    "rs_mission_desc": "To provide premium steel products engineered to the highest global standards—offering superior weather and corrosion resistance at competitive prices—while maintaining an absolute commitment to social and environmental responsibility.",
    "rs_products_title": "Products & Production Capacity",
    "rs_products_desc": "Our industrial complex is engineered to operate with a massive production capacity of up to 20,000 metric tons per month. Our core product portfolio includes:",
    "rs_prod1_title": "Color-Coated Steel Coils",
    "rs_prod1_desc": "(Capacity: 8,000 tons/month) Formulated with premium-grade, anti-corrosive coatings tailored to meet diverse market specifications and color profiles.",
    "rs_prod2_title": "Galvanized Steel Coils",
    "rs_prod2_desc": "(Capacity: 12,000 tons/month) Coated with zinc or chromium layers to provide ultimate resistance against humidity, rain, and corrosion, thereby extending the lifecycle of the steel.",
    "rs_target_sectors_title": "Target Sectors & Industries We Serve:",
    "rs_sector1": "Sandwich panel manufacturing plants.",
    "rs_sector2": "Manufacturers of water tanks, electrical poles, and telecommunication towers.",
    "rs_sector3": "Home appliances and electrical goods industries (refrigerators, freezers, washing machines, metal furniture, and shelving).",
    "rs_sector4": "Construction companies, structural engineering firms, and steel framework fabricators.",
    "rs_process_title": "Production Process",
    "rs_process_desc": "To ensure seamless operations, our facility adopts a continuous, 24/7 manufacturing workflow structured across three sequential shifts:",
    "rs_step1_title": "Raw Material Procurement",
    "rs_step1_desc": "Sourcing premium hot/cold-rolled black steel coils from elite global suppliers (such as China).",
    "rs_step2_title": "Coil Opening (Decoiling)",
    "rs_step2_desc": "Seamlessly stitching and feeding coils into the production line to maintain uninterrupted processing.",
    "rs_step3_title": "Cleaning & Surface Treatment",
    "rs_step3_desc": "Washing and chemical treatment of the steel surface using specialized phosphate solutions and industrial shampoos to eliminate residues and scaling.",
    "rs_step4_title": "Pre-Heating",
    "rs_step4_desc": "Thermally preparing the substrate to ensure optimal adhesion for zinc or paint layers.",
    "rs_step5_title": "Coating & Galvanizing",
    "rs_step5_desc": "Executing precise surface coating or hot-dip galvanizing procedures.",
    "rs_step6_title": "Curing & Drying",
    "rs_step6_desc": "Utilizing advanced industrial ovens for high-speed, uniform drying.",
    "rs_step7_title": "Recoiling & Packaging",
    "rs_step7_desc": "Final rewinding and secure industrial packaging, ready for warehousing and global distribution.",
    "rs_env_title": "Environmental & Social Commitment",
    "rs_env_sub1": "Environmental Protection",
    "rs_env_desc1": "Our plant features an integrated Wastewater Treatment Unit (WTP) and advanced filtration systems to strictly prevent harmful emissions and optimize resource efficiency.",
    "rs_env_sub2": "Job Creation",
    "rs_env_desc2": "The project supports the local economy by engaging over 750 personnel during the execution and construction phase, and maintaining over 80 permanent administrative and technical experts during full-scale operations.",
    "rs_swot_title": "Why Choose Us",
    "rs_swot1_title": "Unprecedented Scale",
    "rs_swot1_desc": "The first and largest state-of-the-art industrial complex of its kind in the region.",
    "rs_swot2_title": "Global Quality Standards",
    "rs_swot2_desc": "Engineering products that directly compete with, and substitute, imports from Turkey and Iran.",
    "rs_swot3_title": "Continuous Development",
    "rs_swot3_desc": "Implementing rigorous and ongoing training programs for our technical and engineering teams to master the latest global manufacturing innovations.",
    "rs_address_value": "Erbil Governorate, Kurdistan Region, Iraq."

  },
};
